
(function() {
  var result = { translations: { "fr": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanais", "sq-al": "Albanais - Albanie", "ar": "Arabe", "ar-dz": "Arabe - Alg\xE9rie", "ar-bh": "Arabe - Bahre\xEFn", "ar-eg": "Arabe - \xC9gypte", "ar-iq": "Arabe - Irak", "ar-jo": "Arabe - Jordanie", "ar-kw": "Arabe - Kowe\xEFt", "ar-lb": "Arabe - Liban", "ar-ly": "Arabe - Lybie", "ar-ma": "Arabe - Maroc", "ar-om": "Arabe - Oman", "ar-qa": "Arabe - Qatar", "ar-sa": "Arabe - Arabie saoudite", "ar-sd": "Arabe - Soudan", "ar-sy": "Arabe - Syrie", "ar-tn": "Arabe - Tunisie", "ar-ae": "Arabe - \xC9mirats arabes unis", "ar-ye": "Arabe - Y\xE9men", "as": "Assamais", "az": "Azerba\xEFdjanais", "hy": "Arm\xE9nien", "eu": "Basque", "be": "Bi\xE9lorusse", "be-by": "Bi\xE9lorusse - Bi\xE9lorussie", "bn": "Bengali", "bg": "Bulgare", "bg-bg": "Bulgare - Bulgarie", "bs": "Bosniaque", "ca": "Catalan", "ca-es": "Catalan - Catalogne", "zh": "Chinois", "zh-cn": "Chinois - simplifi\xE9", "zh-hk": "Chinois - Hong Kong", "zh-mo": "Chinois - Macao", "zh-sg": "Chinois - Singapour", "zh-tw": "Chinois - traditionnel", "zh-chs": "Chinois (simplifi\xE9)", "zh-cht": "Chinois (traditionnel)", "zh-hans": "Chinois (Han simplifi\xE9)", "zh-hant": "Chinois (Han traditionnel)", "hr": "Croate", "hr-hr": "Croate - Croatie", "cs": "Tch\xE8que", "cs-cz": "Tch\xE8que - R\xE9publique Tch\xE8que", "da": "Danois", "da-dk": "Danois - Danemark", "nl": "N\xE9erlandais", "nl-be": "N\xE9erlandais - Belgique", "nl-ch": "N\xE9erlandais - Suisse", "nl-lu": "N\xE9erlandais - Luxembourg", "nl-nl": "N\xE9erlandais - Pays-Bas", "en": "Anglais", "en-ae": "Anglais - \xC9mirats arabes unis", "en-au": "Anglais - Australie", "en-be": "Anglais - Belgique", "en-ca": "Anglais - Canada", "en-ch": "Anglais - Suisse", "en-cn": "Anglais - Chine", "en-de": "Anglais - Allemagne", "en-ee": "Anglais - Estonie", "en-es": "Anglais - Espagne", "en-fr": "Anglais - France", "en-hk": "Anglais - Hong Kong", "en-in": "Anglais - Inde", "en-ie": "Anglais - Irlande", "en-ke": "Anglais - Kenya", "en-lu": "Anglais - Luxembourg", "en-my": "Anglais - Malaisie", "en-mt": "Anglais - Malte", "en-mx": "Anglais - Mexique", "en-nl": "Anglais - Pays-Bas", "en-nz": "Anglais - Nouvelle-Z\xE9lande", "en-ph": "Anglais - Philippines", "en-pk": "Anglais - Pakistan", "en-se": "Anglais - Su\xE8de", "en-sg": "Anglais - Singapour", "en-tn": "Anglais - Tunisie", "en-za": "Anglais - Afrique du Sud", "en-gb": "Anglais - Royaume-Uni", "en-us": "Anglais - \xC9tats-Unis", "en-zw": "Anglais - Zimbabwe", "et": "Estonien", "et-ee": "Estonien - Estonie", "fo": "F\xE9ro\xEFen", "fa": "Farsi", "fi": "Finnois", "fi-fi": "Finnois - Finlande", "fil": "Philippin", "fr": "Fran\xE7ais", "fr-be": "Fran\xE7ais - Belgique", "fr-ca": "Fran\xE7ais - Canada", "fr-fr": "Fran\xE7ais - France", "fr-lu": "Fran\xE7ais - Luxembourg", "fr-mc": "Fran\xE7ais - Monaco", "fr-ch": "Fran\xE7ais - Suisse", "fr-tn": "Fran\xE7ais - Tunisie", "gl": "Gallician", "ka": "G\xE9orgien", "de": "Allemand", "de-at": "Allemand - Autriche", "de-de": "Allemand - Allemagne", "de-gr": "Allemand - Gr\xE8ce", "de-li": "Allemand - Liechtenstein", "de-lu": "Allemand - Luxembourg", "de-ch": "Allemand - Suisse", "el": "Grec", "el-cy": "Grec - Chypre", "el-gr": "Grec - Gr\xE8ce", "gu": "Gujarati", "haw": "Hawa\xEFen", "ha": "Haoussa", "he": "H\xE9breu", "he-il": "H\xE9breu - Isra\xEBl", "iw-il": "H\xE9breu - Isra\xEBl", "hi": "Hindi", "hi-in": "Hindi - Inde", "hu": "Hongrois", "hu-hu": "Hongrois - Hongrie", "is": "Islandais", "is-is": "Islandais - Islande", "id": "Indon\xE9sien", "in-id": "Indon\xE9sien - Indon\xE9sie", "ga": "Irlandais", "ga-ie": "Irlandais - Irlande", "it": "Italien", "it-it": "Italien - Italie", "it-ch": "Italien - Suisse", "ja": "Japonais", "ja-jp": "Japonais - Japon", "kn": "Kannada", "kk": "Kazakh", "kok": "Konkani", "ko": "Cor\xE9en", "ko-kr": "Cor\xE9en - Cor\xE9e du Sud", "ku": "Kurde", "ky": "Kirghize", "ky-kg": "Kirghize", "lo": "Laotien", "lv": "Letton", "lv-lv": "Letton - Lettonie", "lt": "Lituanien", "lt-lt": "Lituanien - Lituanie", "mk": "Mac\xE9donien", "mk-mk": "Mac\xE9donien - Mac\xE9doine", "ml": "Malayalam", "ms": "Malais", "ms-bn": "Malais - Brunei", "ms-my": "Malais - Malaisie", "mt": "Maltais", "mt-mt": "Maltais - Malte", "mr": "Marathi", "mn": "Mongol", "my": "Birman", "my-mm": "Birman - Myanmar (Birmanie)", "ne": "N\xE9palais", "no": "Norv\xE9gien", "nb": "Norv\xE9gien bokmal", "nb-no": "Bokmal norv\xE9gien - Norv\xE8ge", "no-no": "Norv\xE9gien - Norv\xE8ge", "pl": "Polonais", "pl-pl": "Polonais - Pologne", "pt": "Portugais", "pt-br": "Portugais - Br\xE9sil", "pt-pt": "Portugais - Portugal", "pa": "Pendjabi", "pa-in": "Pendjabi - Inde", "pa-pk": "Pendjabi - Pakistan", "ro": "Roumain", "ro-ro": "Roumain - Roumanie", "ru": "Russe", "ru-ru": "Russe - Russie", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Cinghalais", "sr": "Serbe", "sr-ba": "Serbie - Bosnie-Herz\xE9govine", "sr-me": "Serbe - Mont\xE9n\xE9gro", "sr-rs": "Serbe - Serbie", "sr-cs": "Serbe - Serbie-et-Mont\xE9n\xE9gro (ancien)", "sk": "Slovaque", "sk-sk": "Slovaque - Slovaquie", "sl": "Slov\xE8ne", "sl-si": "Slov\xE8ne - Slov\xE9nie", "es": "Espagnol", "es-ar": "Espagne - Argentine", "es-bo": "Espagnol - Bolivie", "es-cl": "Espagnol - Chili", "es-co": "Espagnol - Colombie", "es-cr": "Espagnol - Costa Rica", "es-cu": "Espagnol - Cuba", "es-do": "Espagnol - R\xE9publique dominicaine", "es-ec": "Espagnol - \xC9quateur", "es-sv": "Espagnol - Le Salvador", "es-gt": "Espagnol - Guatemala", "es-hn": "Espagnol - Honduras", "es-mx": "Espagnol - Mexique", "es-ni": "Espagnol - Nicaragua", "es-pa": "Espagnol - Panama", "es-py": "Espagnol - Paraguay", "es-pe": "Espagnol - P\xE9rou", "es-pr": "Espagnol - Porto Rico", "es-es": "Espagnol - Espagne", "es-us": "Espagnol - \xC9tats-Unis", "es-uy": "Espagnol - Uruguay", "es-ve": "Espagne - Venezuela", "sw": "Swahili", "sv": "Su\xE9dois", "sv-fi": "Su\xE9dois - Finlande", "sv-se": "Su\xE9dois - Su\xE8de", "sy": "Syrien", "ta": "Tamil", "tt": "Tatar", "te": "T\xE9lougou", "th": "Tha\xEFlandais", "th-th": "Tha\xEFlandais - Tha\xEFlande", "tl": "Tagalog", "tr": "Turc", "tr-tr": "Turc - Turquie", "uk": "Ukrainien", "uk-ua": "Ukrainien - Ukraine", "ur": "Ourdou", "uz": "Ouzbek", "vi": "Vietnamien", "vi-vn": "Vietnamien - Vietnam", "yi": "Yiddish", "zu": "Zoulou" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": " {{amountNumberValue}}\xA0{{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "fr": { "videoPlayer": { "htmlTitle": "Vid\xE9o HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Vid\xE9o", "controls": { "audioPlayer": "Lecteur audio", "videoPlayer": "Lecteur vid\xE9o", "play": "Lecture", "playVideo": "Lire la vid\xE9o", "pause": "Interrompre", "replay": "Rejouer", "currentTime": "Temps actuel", "duration": "Dur\xE9e", "remainingTime": "Temps restant", "fullscreen": "Plein \xE9cran", "exitFullscreen": "Quitter le mode plein \xE9cran", "mute": "D\xE9sactiver le microphone", "unmute": "Activer le microphone", "volumeLevel": "Niveau de volume", "captions": "L\xE9gendes", "captionsOff": "D\xE9sactiv\xE9", "seekBar": "Ajuster la posiiton", "chapter": "Chapitre", "elapsedTime": "Temps \xE9coul\xE9\xA0: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Options de lecture", "playbackRate": "Vitesse de lecture\xA0:", "quality": "Qualit\xE9 :", "normal": "Normale", "auto": "(Automatique)" }, "formModal": { "defaultThankYouMessage": "Merci pour votre r\xE9ponse\xA0!", "inlineMessageButton": "Regarder la vid\xE9o" }, "ctaModal": { "imgAlt": "CTA de la vid\xE9o" }, "errors": { "generic": { "heading": "Impossible de charger la vid\xE9o" }, "UNAUTHORIZED": { "heading": "Vid\xE9o non activ\xE9e" }, "VIDEO_NOT_FOUND": { "heading": "Vid\xE9o introuvable" }, "INVALID_URL": { "heading": "Vid\xE9o introuvable" }, "UNSUPPORTED_EMBED": { "heading": "Vid\xE9o non disponible", "extra": "Cette vid\xE9o ne peut pas \xEAtre consult\xE9e en externe." }, "refreshLink": "R\xE9essayer" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "fr": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:fr', {version: 'static-1.29208'}); }
})();


